import React from 'react';
import Close from '../assets/images/AltCloseIcon.svg';

export default () => {
  return <img src={Close} alt="close" />;
};
